import React from 'react'
import violationsStubIllustration from '../../../../shared/assets/violations-stub-illustration.svg'
import submittedStubIllustration from '../../../../shared/assets/submitted-stub-illustration.svg'
import removedStubIllustration from '../../../../shared/assets/removed-stub-illustration.svg'
import { StubContactLinks } from '../../../../lib/widgets/stubs/StubContactLinks'

export const NoViolationsStub = () => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[684px] flex-col items-center gap-[24px]'}>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div className={'flex flex-col items-center'}>
            <h2 className={'text-center text-[24px]'}>No violations found yet</h2>
          </div>
        </div>
        <div className={'grid w-full grid-cols-1 justify-center gap-[40px] md:grid-cols-3'}>
          <div className={'flex flex-col items-center gap-[8px]'}>
            <div className={'pb-[8px]'}>
              <img src={violationsStubIllustration} />
            </div>
            <div
              className={
                'flex h-[24px] w-[24px] items-center justify-center rounded-full text-[13px] font-medium text-[#8E7CA7] shadow-outline shadow-focus/[0.65]'
              }
            >
              1
            </div>
            <p className={'text-center text-[15px] text-focus-500'}>
              As soon as Bluepear finds a trademark infringement, you will see a full list of ads
              with evidence
            </p>
          </div>
          <div className={'flex flex-col items-center gap-[8px]'}>
            <div className={'pb-[8px]'}>
              <img src={submittedStubIllustration} />
            </div>
            <div
              className={
                'flex h-[24px] w-[24px] items-center justify-center rounded-full text-[13px] font-medium text-[#8E7CA7] shadow-outline shadow-focus/[0.65]'
              }
            >
              2
            </div>
            <p className={'text-center text-[15px] text-focus-500'}>
              Submit a complaint to Google and track its progress status
            </p>
          </div>
          <div className={'flex flex-col items-center gap-[8px]'}>
            <div className={'pb-[8px]'}>
              <img src={removedStubIllustration} />
            </div>
            <div
              className={
                'flex h-[24px] w-[24px] items-center justify-center rounded-full text-[13px] font-medium text-[#8E7CA7] shadow-outline shadow-focus/[0.65]'
              }
            >
              3
            </div>
            <p className={'text-center text-[15px] text-focus-500'}>
              Once the ad is removed from search, you&apos;ll see a chart confirming it
            </p>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>Contact us for help</p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
